<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<button (click)="toggleProgramFavorite()" class="btn btn-sm btn-light me-2"><i [ngClass]="isProgramFavorite() ? 'fa-icon-active fa fa-star' : 'non-favorite fa fa-star'"></i></button>
		@if (modeView === ModeView.VIEW) {
			<span jhiTranslate="ontology-manager.tab.variables.modal.detail.header"></span>
		} @else if (modeView === ModeView.EDIT) {
			<span jhiTranslate="ontology-manager.tab.variables.modal.edit.header"></span>
		} @else if (modeView === ModeView.CREATE) {
			<span jhiTranslate="ontology-manager.tab.variables.modal.create.header"></span>
		}
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal"
			(click)="clear()">
	</button>
</div>
<div class="modal-body">
	@if (showNoEditableFieldAlert()) {
		<div class="row">
			<div class="col">
				<div class="alert alert-warning" role="alert">
					<i class="fa fa-warning pe-2"></i>
					<span jhiTranslate="ontology-manager.validation.variable.noneditableFields"></span>
				</div>
			</div>
		</div>
	}
	<form name="form" #f="ngForm">
		<div class="mb-3 row">
			<label for="variableName" class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.tab.variables.modal.variable.name">Name</label>
			<div class="col-sm-9">
				<jhi-input
					name="variableName"
					[property]="'name'"
					[model]="variableDetails"
					[modeView]="modeView"
					[disabled]="isLoading"
					[required]="true"
					[maxLength]="NAME_TEXT_LIMIT"
					[pattern]="NAME_ALIAS_PATTERN"
					[(ngModel)]="variableDetails.name"
					#variableName="ngModel">
				</jhi-input>
				@if ((f.submitted || variableName.touched) && variableName.errors?.required) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.name.required' | translate }}</div>
				} @else if ((f.submitted || variableName.dirty) && variableName.errors?.maxlength) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.field.maxlength' | translate : { maxLength: NAME_TEXT_LIMIT } }}</div>
				} @else if ((f.submitted || variableName.dirty) && variableName.errors?.pattern) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.variable.name.pattern' | translate }}</div>
				}
			</div>
		</div>
		@if (showAliasField) {
			<div class="mb-3 row">
				<label for="alias" class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.tab.variables.modal.variable.alias">Alias</label>
				<div class="col-sm-9">
					<jhi-input
						name="alias"
						[property]="'alias'"
						[model]="variableDetails"
						[modeView]="modeView"
						[required]="false"
						[maxLength]="ALIAS_TEXT_LIMIT"
						[pattern]="NAME_ALIAS_PATTERN"
						[(ngModel)]="variableDetails.alias"
						[defaultValue]="'-'"
						#alias="ngModel">
					</jhi-input>
					@if (modeView === ModeView.CREATE && alias.valid) {
						<small class="pt-2">{{ 'ontology-manager.tab.variables.modal.variable.alias.comment' | translate }}</small>
					}
					@if (f.submitted || alias.dirty) {
						@if (alias.errors?.maxlength) {
							<div class="text-danger pt-2">{{ 'ontology-manager.validation.field.maxlength' | translate : { maxLength: ALIAS_TEXT_LIMIT } }}</div>
						} @else if (alias.errors?.pattern) {
							<div class="text-danger pt-2">{{ 'ontology-manager.validation.alias.pattern' | translate }}</div>
						}
					}
				</div>
			</div>
		}
		<div class="mb-3 row">
			<label for="description" class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.tab.variables.modal.variable.description">Description</label>
			<div class="col-sm-9">
				<jhi-textarea
					name="description"
					[modeView]="modeView"
					[model]="variableDetails"
					[property]="'description'"
					[disabled]="isLoading"
					[required]="false"
					[maxLength]="DESCRIPTION_TEXT_LIMIT"
					[pattern]="SPECIAL_CHARACTERS"
					[(ngModel)]="variableDetails.description"
					#description="ngModel">
				</jhi-textarea>
				@if (f.submitted || description.dirty) {
					@if (description.errors?.maxlength) {
						<div class="text-danger pt-2">{{ 'ontology-manager.validation.field.maxlength' | translate : { maxLength: DESCRIPTION_TEXT_LIMIT } }}</div>
					} @else if (description.errors?.pattern) {
						<div class="text-danger pt-2">{{ 'ontology-manager.validation.description.pattern' | translate : { pattern: SPECIAL_CHARACTERS } }}</div>
					}
				}
			</div>
		</div>
		<div class="mb-3 row">
			<label for="property" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.variables.modal.variable.property">Property</label>
			<div [ngClass]="modeView !== 'CREATE' ? 'col-sm-9' : 'col-sm-6'">
				<jhi-select
					name="property"
					id="property"
					[modeView]="modeView"
					[model]="variableDetails"
					[options]="properties"
					[required]="true"
					[property]="'property'"
					[returnType]="'object'"
					[disabled]="isLoading"
					[labelField]="'name'"
					[idField]="'id'"
					(ngModelChange)="onPropertyChanged($event)"
					[(ngModel)]="variableDetails.property"
					[link]="'properties'"
					[placeholder]="'ontology-manager.property.dropdown.placeholder' | translate"
					#propertyCtrl="ngModel"
				></jhi-select>
			</div>
			@if (modeView === ModeView.CREATE) {
				<div class="col-sm-3">
					<a href="javascript:void(0)" (click)="addNewProperty()" jhiTranslate="ontology-manager.property.dropdown.add.new.property"></a>
				</div>
			}
		</div>
		<div class="mb-3 row">
			<label for="method" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.variables.modal.variable.method">Method</label>
			<div [ngClass]="modeView !== 'CREATE' ? 'col-sm-9' : 'col-sm-6'">
				<jhi-select
					name="method"
					id="method"
					[modeView]="modeView"
					[model]="variableDetails"
					[options]="methods"
					[required]="true"
					[property]="'method'"
					[returnType]="'object'"
					[disabled]="isLoading"
					[labelField]="'name'"
					[idField]="'id'"
					(ngModelChange)="onMethodChanged($event)"
					[(ngModel)]="variableDetails.method"
					[link]="'methods'"
					[placeholder]="'ontology-manager.method.dropdown.placeholder' | translate"
					#methodCtrl="ngModel"
				></jhi-select>
			</div>
			@if (modeView === ModeView.CREATE) {
				<div class="col-sm-3">
					<a href="javascript:void(0)" (click)="addNewMethod()" jhiTranslate="ontology-manager.method.dropdown.add.new.method"></a>
				</div>
			}
		</div>
		<div class="mb-3 row">
			<label for="scale" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.variables.modal.variable.scale">Scale</label>
			<div [ngClass]="modeView !== 'CREATE' ? 'col-sm-9' : 'col-sm-6'">
				<jhi-select
					name="scale"
					[modeView]="modeView"
					[model]="variableDetails"
					[options]="scales"
					[required]="true"
					[property]="'scale'"
					[returnType]="'object'"
					[disabled]="isLoading"
					[labelField]="'name'"
					[idField]="'id'"
					(ngModelChange)="onScaleChanged($event)"
					[(ngModel)]="variableDetails.scale"
					[link]="'scales'"
					[placeholder]="'ontology-manager.scale.dropdown.placeholder' | translate"
					#scaleCtrl="ngModel"
				></jhi-select>
			</div>
			@if (modeView === ModeView.CREATE) {
				<div class="col-sm-3">
					<a href="javascript:void(0)" (click)="addNewScale()" jhiTranslate="ontology-manager.scale.dropdown.add.new.scale"></a>
				</div>
			}
		</div>
		<div class="mb-3 row">
			<label for="variableType" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.variables.modal.variable.type">Variable Type</label>
			<div class="col-sm-9">
				<jhi-multi-select
					name="variableType"
					[modeView]="modeView"
					[model]="variableDetails"
					[property]="'variableTypes'"
					[options]="variableTypes"
					[required]="true"
					[appendable]="true"
					[labelField]="'name'"
					[idField]="'id'"
					[placeholder]="'ontology-manager.variable.type.dropdown.placeholder' | translate"
					(ngModelChange)="onVariableTypeChanged($event)"
					[(ngModel)]="variableDetails.variableTypes"
					#variableTypeCtrl="ngModel">
				</jhi-multi-select>
				@if (modeView === ModeView.EDIT) {
					<small>{{ 'ontology-manager.tab.variables.modal.variable.type.comment' | translate }}</small>
				}
				@if (modeView !== ModeView.VIEW && invalidAnalysisScaleConbination) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.invalid.analysis.variable.type.scale.combination' | translate }}</div>
				}
				@if (modeView === ModeView.VIEW) {
					<a href="javascript:void(0)" (click)="filterbyVariableType()">
						{{ 'ontology-manager.variable.with.similar.types' | translate }}
					</a>
				}
			</div>
		</div>
		<div class="mb-3 row" *ngIf="showParenVariable">
			<label for="type" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.variables.modal.variable.parent.variable">Parent variable</label>
			<div class="col-sm-9">
				@if (modeView === ModeView.VIEW || (modeView === ModeView.EDIT && !canEditFieldByMetadata(variableDetails, 'parentVariable'))) {
					<truncate-span [textInput]="variableDetails?.parentVariable?.name?variableDetails.parentVariable.name:'-'"></truncate-span>
				} @else {
					<jhi-variable-select name="dropdownvariable" id="dropdownvariable"
										 (onVariableSelectedChange)="selectVariable($event)"
										 [value]="variableDetails?.parentVariable?.id"
										 [variableTypeIds]="[1808]"
										 [propertyIds]="variableDetails?.property?.id ? [variableDetails?.property?.id] : []"
										 [disabled]="isLoading">
					</jhi-variable-select>
				}
			</div>
		</div>
		<div *ngIf="showRangeWidget">
			<div class="mb-3 row">
				<label for="type" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.scales.modal.scale.valid-range">Valid Range</label>
				<div class="col-sm-9">
					<jhi-numeric-range name="numericRange"
									   [modeView]="modeView"
									   [model]="variableDetails"
									   [property]="'expectedRange'"
									   [numeric]="showRangeWidget"
									   [min]="variableDetails.scale.validValues ? variableDetails.scale.validValues.min : MIN_RANGE"
									   [max]="variableDetails.scale.validValues ? variableDetails.scale.validValues.max : MAX_RANGE"
									   [disabled]="isLoading"
									   [(ngModel)]="variableDetails.expectedRange"
									   #numericRange="ngModel">
					</jhi-numeric-range>
					@if (modeView === ModeView.EDIT && variableDetails?.scale?.validValues?.min && variableDetails?.scale?.validValues?.max) {
						<small>{{ 'ontology-manager.variable.search.columns.variable-scale.comment' | translate : { min: variableDetails.scale.validValues.min, max: variableDetails.scale.validValues.max } }}</small>
					}
					@if (f.submitted || numericRange.dirty) {
						@if (numericRange.errors?.minTooBig) {
							<div class="text-danger pt-2">
								{{ 'ontology-manager.validation.numeric.range.min.too.big' | translate }}
							</div>
						} @else if (numericRange.errors?.minOutOfRange) {
							<div class="text-danger pt-2">
								{{ 'ontology-manager.validation.numeric.range.min.out.of.range' | translate }}
							</div>
						} @else if (numericRange.errors?.maxOutOfRange) {
							<div class="text-danger pt-2">
								{{ 'ontology-manager.validation.numeric.range.max.out.of.range' | translate }}
							</div>
						}
					}
				</div>
			</div>
		</div>
		@if (modeView !== ModeView.CREATE) {
			<div class="mb-3 row">
				<label for="type" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.variables.modal.variable.is.obsolete">Is obsolete?</label>
				<div class="col-sm-9">
					<div class=" form-check form-check-inline">
						<input class="form-check-input" type="radio" name="obsolete" id="obsoleteYes" [value]="ObsoleteEnum.YES" [(ngModel)]="obsoleteVariable" [disabled]="isObsoleteDisable()" (change)="onObsoleteChanged()">
						<label for="obsoleteYes" class="ms-1 form-check-label" jhiTranslate="yes"></label>
					</div>
					<div class=" form-check form-check-inline">
						<input class="form-check-input" type="radio" name="obsolete" id="obsoleteNo" [value]="ObsoleteEnum.NO" [(ngModel)]="obsoleteVariable" [disabled]="isObsoleteDisable()" (change)="onObsoleteChanged()">
						<label for="obsoleteNo" class="ms-1 form-check-label" jhiTranslate="no"></label>
					</div>
				</div>
			</div>
		}
	</form>
	<br>
	<jhi-formula [modeView]="modeView" [variable]="variableDetails" [isFormulaExpanded]="true"></jhi-formula>
	<br>
	<jhi-metadata [modeView]="modeView" [metadata]="variableDetails.metadata" [extendedUsage]="true"></jhi-metadata>
</div>
<div class="modal-footer">
	@if (modeView === ModeView.EDIT || modeView === ModeView.CREATE) {
		<button type="button" class="btn btn-secondary" (click)="discard()">
			<span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="discard"></span>
		</button>
		<button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span class="fa fa-save"></span>&nbsp;
			@if (modeView === ModeView.EDIT) {
				<span jhiTranslate="update"></span>
			} @else {
				<span jhiTranslate="create"></span>
			}
		</button>
	} @else {
		<button type="button" class="btn btn-secondary" (click)="back()">
			<span jhiTranslate="back"></span>
		</button>
		@if (isDeletable()) {
			<button type="button" class="btn btn-info me-2" (click)="delete()">
				<span class="fa fa-trash"></span>&nbsp;<span jhiTranslate="delete"></span>
			</button>
		}
		<button type="button" class="btn btn-outline-info" (click)="edit()">
			<span class="fa fa-pencil"></span>&nbsp;<span jhiTranslate="edit"></span>
		</button>
	}
</div>
